import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import propTypes from 'prop-types';
import { useBreakpointValue, Modal as Modal$1, ModalOverlay, ModalContent, ModalHeader, Text, ModalCloseButton, ModalBody, ModalFooter } from '@chakra-ui/react';
import { IconButton } from '@outdoorly/button';
import { ArrowLeftIcon } from '@outdoorly/icons';

var _excluded = ["title", "hasBackButton", "onBackButton", "hasCloseButton", "children", "footer", "isOpen", "onClose", "size", "fullScreen", "contentProps"];

/**
 * A modal with opinionated defaults for both desktop and mobile to match Outdoorly designs.
 */
var Modal = function Modal(_ref) {
  var title = _ref.title,
    _ref$hasBackButton = _ref.hasBackButton,
    hasBackButton = _ref$hasBackButton === void 0 ? false : _ref$hasBackButton,
    onBackButton = _ref.onBackButton,
    _ref$hasCloseButton = _ref.hasCloseButton,
    hasCloseButton = _ref$hasCloseButton === void 0 ? true : _ref$hasCloseButton,
    children = _ref.children,
    footer = _ref.footer,
    isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'xl' : _ref$size,
    _ref$fullScreen = _ref.fullScreen,
    fullScreen = _ref$fullScreen === void 0 ? false : _ref$fullScreen,
    _ref$contentProps = _ref.contentProps,
    contentProps = _ref$contentProps === void 0 ? {} : _ref$contentProps,
    props = _objectWithoutProperties(_ref, _excluded);
  var breakpoint = useBreakpointValue({
    base: 'mobile',
    md: 'desktop'
  });
  return /*#__PURE__*/React.createElement(Modal$1, _extends({
    isOpen: isOpen,
    onClose: onClose,
    scrollBehavior: breakpoint === 'mobile' ? 'inside' : 'outside',
    size: fullScreen ? 'full' : breakpoint === 'mobile' ? 'full' : size
  }, props), /*#__PURE__*/React.createElement(ModalOverlay, null), /*#__PURE__*/React.createElement(ModalContent, _extends({}, contentProps, {
    minHeight: fullScreen ? '100%' : breakpoint === 'desktop' ? undefined : '100%',
    margin: fullScreen ? 0 : breakpoint === 'mobile' ? 0 : null,
    padding: 0,
    borderRadius: fullScreen ? 0 : breakpoint === 'desktop' ? '2xl' : null
  }), (hasBackButton || title) && /*#__PURE__*/React.createElement(ModalHeader, {
    borderColor: "scheme.border",
    borderBottomWidth: "1px"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: breakpoint === 'desktop' ? 'xl' : 'lg',
    fontWeight: "500",
    align: "center",
    pt: breakpoint === 'desktop' ? 1 : null
  }, title), hasBackButton && (breakpoint === 'desktop' ? /*#__PURE__*/React.createElement(IconButton, {
    onClick: onBackButton,
    variant: "ghost",
    icon: /*#__PURE__*/React.createElement(ArrowLeftIcon, {
      width: 6,
      height: 6
    }),
    position: "absolute",
    borderRadius: "2xl",
    top: 3,
    left: 3,
    p: 6,
    zIndex: 100,
    sx: {
      ':hover': {
        background: 'rgba(0,0,0,0.06)'
      }
    }
  }) : /*#__PURE__*/React.createElement(IconButton, {
    onClick: onBackButton,
    variant: "ghost",
    icon: /*#__PURE__*/React.createElement(ArrowLeftIcon, {
      width: 5,
      height: 5
    }),
    position: "absolute",
    borderRadius: "md",
    top: 3,
    left: 3,
    size: "sm",
    px: 0,
    zIndex: 100,
    sx: {
      ':hover': {
        background: 'rgba(0,0,0,0.06)'
      }
    }
  }))), hasCloseButton && (breakpoint === 'desktop' ? /*#__PURE__*/React.createElement(ModalCloseButton, {
    size: 10,
    padding: 4,
    borderRadius: "2xl",
    mt: 1,
    zIndex: "docked"
  }) : /*#__PURE__*/React.createElement(ModalCloseButton, {
    mt: 1,
    zIndex: "docked"
  })), /*#__PURE__*/React.createElement(ModalBody, {
    p: fullScreen ? 0 : breakpoint === 'desktop' ? 6 : 4
  }, children), footer && /*#__PURE__*/React.createElement(ModalFooter, {
    p: fullScreen ? 0 : breakpoint === 'desktop' ? 4 : 4,
    borderColor: "scheme.border",
    borderTopWidth: "1px"
  }, footer)));
};
Modal.propTypes = {
  title: propTypes.string,
  hasBackButton: propTypes["boolean"],
  onBackButton: propTypes.func,
  hasCloseButton: propTypes["boolean"],
  footer: propTypes.node,
  children: propTypes.node,
  isOpen: propTypes["boolean"],
  onClose: propTypes.func,
  scrollBehavior: propTypes.string,
  size: propTypes.string,
  fullScreen: propTypes.bool
};

export { Modal };
